<template>
    <div style="padding:1px;">
      <hd></hd>
      <div class="snatched">
          <img :src="productqrcode" style="border:1px solid;padding:5px 0"/>
          <vue-canvas-poster :widthPixels="0" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
      </div>
      <ft class="ft"></ft>
    </div>
</template>
<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import Loading from '../../components/Loading'
import mobilefooter from '../../components/mobilefooter'
import api from '../../services/api.js'

export default {
  name: 'ProductCode',
  components: {
    hd: hd,
    mobilefooter: mobilefooter,
    ft: ft,
    Loading: Loading
  },
  data () {
    return {
      productid:'',
      productqrcode:'',
      painting:{},
      goodspainting:{
        width:`250px`,
        height:`380px`,
        background: '#fff',
        views: [
          {
            type: 'image',
            url: '',
            css: {
              width:`250px`,
              height:`250px`,
              mode:'aspectFill',
              left:'0',
              top: '0'
            }
          },
          {
            type: 'rect',
            css: 
              {
                //paintingWidth:250,
                top:'250px',
                color:'#444',
                width:'250px',
                height:'25px'
              }
            
          },
          {
            type: 'text',
            text: '长按识别，下单购买 >',
            css: 
              {
                //paintingWidth:250,
                top:'255px',
                color:'#fff',
                fontSize: '13px',
                textAlign:'left',
                padding:'10px'
              }
            
          },
          {
            type: 'rect',
            css: {
              width:`100px`,
              height:`100px`,
              color:'#fff',
              borderRadius:'50px',
              right:'2px',
              top: '210px'
            }
          },
          {
            type: 'image',
            url: '',
            css: {
              width:`90px`,
              height:`90px`,
              right:'7px',
              top: '215px'
            }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'280px',
                color:'#000',
                fontSize: '25px',
                textAlign:'left',
                padding:'10px',
              }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'290px',
                left: '80px',
                color:'#000',
                fontSize: '15px',
                textAlign:'left',
                padding:'10px',
              }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'318px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
                maxLines:'2',
                width: '230px',
                lineHeight: '20px',
              }
          },
        ],
      },
    }
  },
  mounted () {
    this.productid=this.$route.params.id?this.$route.params.id:0
    if(this.productid)
      this.generateCode()
  },
  methods: {
    fail(err) {
      console.log('fail', err)
    },
    success(src) {
      this.productqrcode=src;
    },
    generateCode(){
      let params={}
      api.get(this, {
            path: 'good.php',
            api: 'get_detail_by_sku',
            params: {
              sku:this.productid
            },
            loading: 'loading'
          }).then((goods)=>{
            console.log(goods)
            goods=goods.body;
            params={
              page: 'pages/product-detail/product-detail',
              is_hyaline: true,
              scene: goods.result.id
            }
            api.post(this, {
                path: 'good.php',
                data: params,
                loading: 'loading',
                api: 'create_qr_code'
            }).then((res)=>{
              this.$set(this.goodspainting.views[0], 'url', goods.result.cover_image.small);
              this.$set(this.goodspainting.views[4], 'url', res.body);
              this.$set(this.goodspainting.views[5], 'text', `${goods.result.currency_symbol}${goods.result.discounted_price}`);
              this.$set(this.goodspainting.views[6], 'text', `${goods.result.currency}`);
              if(+goods.result.discounted_price>=1000){
                this.$set(this.goodspainting.views[6].css, 'left', `100px`);
              }
              else if(+goods.result.discounted_price>=100){
                this.$set(this.goodspainting.views[6].css, 'left', `90px`);
              }
              else if(+goods.result.discounted_price>=10){
                this.$set(this.goodspainting.views[6].css, 'left', `85px`);
              }
              this.$set(this.goodspainting.views[7], 'text', goods.result.name_cn || goods.result.name);
              this.painting=JSON.parse(JSON.stringify(this.goodspainting))

            })
          })
    },
  },
}

</script>
<style scoped lang="scss">
.snatched {
    margin: 0 auto 60px;;
    margin-top: 180px;
    // width: 914px;
    padding: 0 20%;
    text-align: center;
}
    @media screen and (max-width:1375px){
        .snatched {
            padding: 0 15%;
        }
    }
    @media screen and (max-width:1200px){
        .snatched {
            padding: 0 10%;
        }
    }
    @media screen and (max-width:1025px){
        .snatched {
            padding: 0 10px;
            margin-top: 100px;
            .toggleList {
                padding-left: 0 !important;

                .toggle{

                    width: 100%;
                    margin-bottom: 20px;
                }
            }

            .button {
                float: left;
            }

            .pool {
                margin-top: 20px;
                .poolTitle {
                    display: block;
                    width: 250px !important;
                    font-size: 14px;
                }
            }
        }
    }
    @media screen and (max-width:750px){
        .snatched {
            .pool {

                .goods  {

                    .left-content {
                        width: 100%;
                        margin-bottom: 20px;

                        .goodsList {

                            .order-des {
                                float: right !important;
                                width: 50% !important;
                            }
                        }
                    }

                    .right-operation {
                        .mobile-button {
                            width: 268px !important;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/qrcode/productCode.vue